import { useEffect, useState } from "react";

import "./App.css";

import { Spinner } from "reactstrap";

import FormArea from "./components/FormArea";

import config from "./store/config";

let isInitial = true;
let defaultConfiguratorState = {
  skuId: 86,
  cartItemId: 0,
  apiEndpoint: "http://localhost:25291/",
  productCollection: 2,
  csrfToken: ''
};

if (typeof window.SMA_DEFAULT_CONFIG !== "undefined") {
  config.settings = window.SMA_DEFAULT_CONFIG;
  defaultConfiguratorState = window.SMA_DEFAULT_CONFIG;
}

function App() {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [donationData, setDonationData] = useState(null);

  // load configurator state from api
  useEffect(() => {
    if (isInitial) {
      const fetchData = async () => {
        
        let url = config.settings.apiEndpoint + 'api/requests/GetDonationDefaults/' + config.settings.skuId;
        if(config.settings.cartItemId) {
          url = config.settings.apiEndpoint + 'api/requests/GetDonationDefaults/' + config.settings.skuId + '/' + config.settings.cartItemId;
        }

        const response = await fetch(
          url,
          {
            method: 'GET',
            credentials: "include",
            headers: {
              'RequestVerificationToken': window.AntiForgeryToken
            }
          }
        );

        if (!response.ok) {
          throw new Error('Could not fetch configurator data!');
        }

        const data = await response.json();

        setDonationData(data);
        setIsDataLoaded(true);

      };

      fetchData();
      isInitial = false;
    }
  }, []);

  if (isDataLoaded) {
    return (
      <div className="cfg">
        <div className="row">
          <div className="col-12">
            <FormArea donation={donationData} />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="loading-spinner">
        <Spinner color="primary">Loading...</Spinner>
      </div>
    );
  }
}

export default App;
